export const convert = (str) => {
  let date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
  return [mnth, day, date.getFullYear()].join('/');
};

export const convertDate = (str, order, seprator) => {
  let date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
  let dateForm = null;
  switch (order) {
    case 'MMDDYYYY':
      dateForm = [mnth, day, date.getFullYear()].join(seprator);
      break;
    case 'DDMMYYYY':
      dateForm = [day, mnth, date.getFullYear()].join(seprator);
      break;
    case 'YYYYMMDD':
      dateForm = [date.getFullYear(), mnth, day].join(seprator);
      break;
  }
  return dateForm;
};